import { Grid } from "@mui/material";
import jwt_decode from "jwt-decode";
import { useState } from "react";
import { useDispatch } from "react-redux";
import CustomButton from "../../components/CustomButton";
import CustomTextField from "../../components/CustomTextField";
import { registerClinicUser } from "../../redux/reducers/clinicSlice";
import { generate4DigitRandomNumber } from "../../util/function";

const initValues = {
  petName: "",
  parentName: "",
  address: "",
  userMobile: "",
  email: "",
  password: "",
  rfid: "",
  weight: "",
  breed: null,
  petType: null,
  color: null,
  gender: null,
  reproductiveStatus: null,
  ageType: "Year",
  dob: null,
  image: null,
  bloodGroup: null,
  temperament: null,
  ownershipType: null,
};

const initErrors = {
  petName: "",
  dob: "",
  breed: "",
  gender: "",
  address: "",
  reproductiveStatus: "",
  weight: "",
  parentName: "",
  userMobile: "",
  email: "",
  password: "",
  color: "",
  petType: "",
  rfId: "",
  bloodGroup: "",
  temperament: "",
};

const UserRegistration = ({ setSelectedUser }) => {
  const dispatch = useDispatch();
  const [petValues, setPetValues] = useState(initValues);
  const [errors, setErrors] = useState(initErrors);

  const handleInputChange = (e, field) => {
    const reqObj = { ...petValues, [field]: e?.target?.value };
    if (field === "ownershipType" && e?.target?.value === "Rescue") {
      reqObj.petName = `Stray-${generate4DigitRandomNumber()}`;
    }
    setPetValues(reqObj);
    setErrors((prevErrors) => ({ ...prevErrors, [field]: "" }));
  };

  const validateParentFields = () => {
    const newErrors = {};
    if (!petValues?.parentName) newErrors.parentName = "This field is required";
    if (!petValues?.userMobile) newErrors.userMobile = "This field is required";
    if (petValues?.email?.length > 0 && !petValues?.email.includes("@")) {
      newErrors.email = "Invalid email format";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleNext = () => {
    if (!validateParentFields()) return;
    const data = new FormData();

    data.append("userName", petValues?.parentName);
    data.append("userMobile", petValues?.userMobile);
    if (petValues?.address?.length > 0)
      data.append("address", petValues?.address);
    if (petValues?.email?.length > 0) data.append("email", petValues?.email);
    if (petValues?.secondaryMobile?.length > 0) {
      data.append("secondaryMobile", petValues?.secondaryMobile);
    }
    dispatch(registerClinicUser(data)).then((res) => {
      if (res?.payload) {
        const decoded = jwt_decode(res?.payload?.baseUrl?.split("=")?.pop());
        const reqObj = {
          ...(decoded ?? {}),
          userId: decoded?.id,
          clinicId: decoded?.clinicId,
          name: petValues?.parentName,
          email: petValues?.email,
          mobile: petValues?.userMobile,
        };
        setSelectedUser(
          res?.payload?.baseUrl?.length > 0 && decoded
            ? reqObj
            : res?.payload?.data
        );
        setPetValues({});
        setErrors({});
      }
    });
  };

  return (
    <div className="flex-center">
      <div className="w90Per">
        <Grid container spacing={2} className="mt10">
          <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
            <div>
              <CustomTextField
                label="Parent Name"
                name="parentName"
                fullWidth
                handleChange={(e) => handleInputChange(e, "parentName")}
                value={petValues?.parentName}
                error={!!errors.parentName}
                helperText={errors.parentName}
                required={true}
              />
            </div>
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
            <div>
              <CustomTextField
                label="Contact Number"
                name="userMobile"
                fullWidth
                handleChange={(e) => handleInputChange(e, "userMobile")}
                value={petValues?.userMobile}
                error={!!errors.userMobile}
                helperText={errors.userMobile}
                required={true}
              />
            </div>
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
            <div>
              <CustomTextField
                label="Email"
                name="email"
                fullWidth
                handleChange={(e) => handleInputChange(e, "email")}
                value={petValues?.email}
                error={!!errors.email}
                helperText={errors.email}
                required={true}
              />
            </div>
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
            <div>
              <CustomTextField
                label="Secondary Phone Number"
                name="secondaryMobile"
                fullWidth
                handleChange={(e) => handleInputChange(e, "secondaryMobile")}
                value={petValues?.secondaryMobile}
              />
            </div>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <div>
              <CustomTextField
                label="Address"
                name="address"
                fullWidth
                handleChange={(e) => handleInputChange(e, "address")}
                value={petValues?.address}
                labelTop
                multiline
              />
            </div>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <div className="flex-center mt10">
              <div>
                <CustomButton text="Next" smallBtn onClick={handleNext} />
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default UserRegistration;
